export default __webpack_public_path__ + "static/media/Decarbonise_Instructions_Background_facilitators.ba1d271f.pdf";